// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
